import React from 'react';
// Constants
import { CompanyPhoneNumber, CONTACT_PAGE_URL } from '../../utils/Constants';

function MainCta() {
  return (
    <section className='grid' aria-labelledby='contact-section'>
      <div className='grid bg-colour5 px-6 xs:px-12 sm:px-8 md:px-12'>
        <article className='grid gap-4 text-center py-6 lg:py-10'>
          {/* Contact Heading */}
          <section className='grid gap-4' aria-labelledby='contact-heading'>
            <h2 id='contact-heading' className='font-semibold text-3xl'>
              Contact Me Today!
            </h2>
            <p>
              I am happy to discuss any questions you have and provide
              estimates.
            </p>

            {/* Clickable Phone Number */}
            <p>
              <a
                href={`tel:${CompanyPhoneNumber}`}
                className='text-colour2'
                aria-label={`Call me now at ${CompanyPhoneNumber}`}
              >
                <span className='font-medium'>Call Now:</span>{' '}
                {CompanyPhoneNumber}
              </a>
            </p>
          </section>

          {/* Buttons */}
          <section
            className='grid md:grid-cols-2 w-fit mx-auto gap-4 gap-y-2'
            aria-label='Contact options'
          >
            <div className='grid'>
              <a
                href={CONTACT_PAGE_URL}
                className='w-full py-2 px-2 lg:py-2 lg:px-6 text-colour6 bg-colour1 border-colour6 border-2 border-solid rounded-lg lg:text-xl font-semibold md:max-w-[360px] hover:bg-colour2 hover:text-colour1'
                aria-label='Go to the contact page'
              >
                Contact Now
              </a>
            </div>
            <div className='grid'>
              <a
                href={CONTACT_PAGE_URL}
                className='w-full py-2 px-2 lg:py-2 lg:px-6 text-colour6 bg-colour1 border-colour6 border-2 border-solid rounded-lg lg:text-xl font-semibold md:max-w-[360px] hover:bg-colour2 hover:text-colour1'
                aria-label='Request a free quote'
              >
                Get a Free Quote Now!
              </a>
            </div>
          </section>
        </article>
      </div>
    </section>
  );
}

export default MainCta;
